import React, {Component} from 'react';
import {Progress} from 'semantic-ui-react';

class AmountProgress extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  getColor(percentage) {
    if (percentage < 33) {
      return 'green';
    }
    if (percentage > 66) {
      return 'red';
    }

    return 'yellow';
  }

  render() {
    const {projected, spent} = this.props;
    const percentage = Math.round((Number(spent || 0) / Number(projected || 1)) * 100);
    const color = this.getColor(percentage);

    return (
      <Progress size='small' progress='percent' percent={percentage} color={color} />
    );
  }
}

export default AmountProgress;
